import Vista from "../../components/Vista"
import { CircularProgress, Grid } from "@mui/material"
import { EstilosButton, productDetails } from "../../utils/styles"
import { useHistory } from "react-router-dom"
import { useLocalStorage } from "../../hooks/useLocalStorage"
import { NavLink } from "react-router-dom/cjs/react-router-dom.min"
import { useEffect, useState } from "react"
import Input from "../../components/Input"
import { LoadingButton } from "@mui/lab"
import Servo from "../../services/servo"
import { useMessages } from "../../hooks/useMessages"
import AutocompleteDeluxe from "../../components/AutocompleteDelux"

let vs = productDetails()
let VS2 = EstilosButton()

const Detail = ({ match }) => {
  let EstilosButton = VS2()
  let productDetails = vs()
  const history = useHistory()
  const { setMessages } = useMessages()
  const permisoCheck = "herramientasPrestadas"
  const [permiso] = useLocalStorage("permiso", null)
  const id = match?.params?.id
  const editado = !!id
  const [loadingB, setLoadingB] = useState(false)
  const [loading, setLoading] = useState(false)
  const [formDetails, setformDetails] = useState({})
  const [herramienta, setHerramienta] = useState(null)
  const [usuario, setUsuario] = useState(null)
  const [operacion, setOperacion] = useState("")

  // const getDatos = async () => {
  //   setLoading(true)
  //   let res = await Servo.get("herramientas-prestadas" + "?idHerramienta=" + id)
  //   if (res.cuerpo?.resultado?.length > 0) {
  //     setformDetails((prevFormDetails) => ({
  //       ...prevFormDetails,
  //       ...res.cuerpo?.resultado[0]
  //     }))
  //     setHerramienta({
  //       idHerramienta: res.cuerpo?.resultado[0].herramienta?.idHerramienta,
  //       nombre: res.cuerpo?.resultado[0].herramienta?.nombre
  //     })
  //   }
  //   setLoading(false)
  // }

  const getDatos = async () => {
    setLoading(true)

    let res = await Servo.get(`herramientas?idHerramienta=${id}`)

    if (res.cuerpo?.resultado?.length > 0) {
      const herramientaData = res.cuerpo.resultado[0]

      setHerramienta({
        idHerramienta: herramientaData.idHerramienta,
        nombre: herramientaData.nombre
      })

      setformDetails({})
      setUsuario(null)
      setOperacion("")
    }

    setLoading(false)
  }

  useEffect(() => {
    if (editado) {
      getDatos()
    }
  }, [])

  const guardar = async () => {
    setLoadingB(true)
    let body = {
      ...formDetails,
      idHerramienta: herramienta.idHerramienta,
      idUsuario: usuario.idUsuario,
      operacion: operacion
    }

    // Si fechaPrestamo está vacía, se establece con la fecha actual
    if (!body.fechaPrestamo) {
      body.fechaPrestamo = new Date().toISOString()
    } else {
      // Si fechaPrestamo ya tiene valor, llenamos fechaDevolucion
      body.fechaDevolucion = new Date().toISOString()
    }

    if (editado) {
      body = {
        ...body
      }
    }

    let res = await Servo.post(
      "herramientas-prestadas/guardar",
      body,
      "herramientas",
      true,
      history
    )

    if (res?.cuerpo) {
      setMessages(res?.cuerpo)
    }

    setLoadingB(false)
  }

  return (
    <Vista>
      <div className={productDetails.screenSize}>
        <div className={productDetails.volverCarros}>
          {(permiso[permisoCheck] & 1) === 1 ? (
            <NavLink exact to={"/" + permisoCheck}>
              « Volver
            </NavLink>
          ) : (
            <p>« Volver</p>
          )}
        </div>
        <div className={productDetails.top}>
          <div className={productDetails.title}>
            {editado ? (
              <p>Prestamo de Herramientas</p>
            ) : (
              <p>Prestamo de Herramientas</p>
            )}
          </div>
        </div>
        <div className={productDetails.formArea}>
          <Grid container direction="row" columns={{ xs: 12, sm: 12, md: 12 }}>
            {!loading ? (
              <>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  sx={{
                    "@media (min-width: 600px)": {
                      paddingRight: "10px"
                    }
                  }}
                  className={productDetails.inputArea}
                >
                  <AutocompleteDeluxe
                    labelToShow={"Herramienta"}
                    labelProp={"nombre"}
                    nombre={"herramientas"}
                    value={herramienta}
                    setDato={setHerramienta}
                  />
                  {/* <Input
                    typeInput={"form"}
                    valor={formDetails?.nombre}
                    setValor={setformDetails}
                    placeholder="Nombre de la herramienta"
                    nombre="Herramienta"
                    required="true"
                    onChange={(e) => {
                      setformDetails({
                        ...formDetails,
                        nombre: e.target.value
                      })
                    }}
                  /> */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  sx={{
                    "@media (min-width: 600px)": {
                      paddingRight: "10px"
                    }
                  }}
                  className={productDetails.inputArea}
                >
                  <AutocompleteDeluxe
                    labelToShow={"Usuario"}
                    labelProp={"nombreCompleto"}
                    nombre={"usuarios"}
                    value={usuario}
                    setDato={setUsuario}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  sx={{
                    "@media (min-width: 600px)": {
                      paddingRight: "10px"
                    }
                  }}
                  className={productDetails.inputArea}
                >
                  <Input
                    typeInput={"form"}
                    valor={formDetails?.cantidad}
                    setValor={setformDetails}
                    placeholder="Cantidad"
                    nombre="Cantidad"
                    required="true"
                    onChange={(e) => {
                      setformDetails({
                        ...formDetails,
                        cantidad: e.target.value
                      })
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  sx={{
                    "@media (min-width: 600px)": {
                      paddingRight: "10px"
                    }
                  }}
                  className={productDetails.inputArea}
                >
                  <Input
                    typeInput={"formSelect"}
                    valor={operacion}
                    placeholder="Operacion"
                    nombre="Operacion"
                    onChange={(e) => {
                      setOperacion(e.target.value)
                    }}
                    data={["PRESTAMO", "DEVOLUCION"]}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  sx={{
                    "@media (min-width: 600px)": {
                      paddingRight: "10px"
                    }
                  }}
                  className={productDetails.inputArea}
                >
                  <Input
                    typeInput={"form"}
                    valor={formDetails?.observacion}
                    setValor={setformDetails}
                    placeholder="Observacion"
                    nombre="Observacion"
                    onChange={(e) => {
                      setformDetails({
                        ...formDetails,
                        observacion: e.target.value
                      })
                    }}
                  />
                </Grid>
              </>
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                sx={{
                  "@media (min-width: 600px)": {
                    margin: "100px"
                  }
                }}
                className={productDetails.inputArea}
              >
                <CircularProgress />
              </Grid>
            )}
          </Grid>
        </div>
        <div className={productDetails.buttonArea}>
          {(permiso[permisoCheck] & 2) === 2 ? (
            <LoadingButton
              loading={loadingB}
              onClick={guardar}
              sx={{
                width: "170px",
                height: "50px",
                backgroundColor: "#157CC1",
                fontFamily: "poppins",
                borderRadius: "10px",
                border: "none",
                fontWeight: "500",
                fontSize: "14px",
                letterSpacing: "0.07em",
                color: "#FFFFFF",
                marginLeft: "2px",
                "@media (min-width: 600px)": {
                  marginBottom: "6px"
                },
                "&:hover": {
                  backgroundColor: "#1565c0",
                  cursor: "pointer"
                }
              }}
            >
              GUARDAR
            </LoadingButton>
          ) : (
            <LoadingButton
              onClick={guardar}
              disabled
              sx={{
                width: "170px",
                height: "50px",
                backgroundColor: "#157CC1",
                fontFamily: "poppins",
                borderRadius: "10px",
                border: "none",
                fontWeight: "500",
                fontSize: "14px",
                letterSpacing: "0.07em",
                color: "#FFFFFF",
                marginLeft: "2px",
                "@media (min-width: 600px)": {
                  marginBottom: "6px"
                },
                "&:hover": {
                  backgroundColor: "#1565c0",
                  cursor: "pointer"
                }
              }}
            >
              GUARDAR
            </LoadingButton>
          )}
        </div>
      </div>
    </Vista>
  )
}

export default Detail
